import * as React from 'react';
import { Box } from '@mui/material';
import { DataGridPro } from '@mui/x-data-grid-pro';

const columns = [
  { field: 'id', headerName: 'ID', width: 100 },
  { field: 'name', headerName: 'Name', width: 200 },
  { field: 'email', headerName: 'Email', width: 300 },
  { field: 'address', headerName: 'Address', width: 400 },
  { field: 'phone', headerName: 'Phone', width: 200 },
  { field: 'company', headerName: 'Company', width: 250 },
];

const rows = Array.from({ length: 20 }, (_, i) => ({
  id: i,
  name: `User ${i}`,
  email: `user${i}@example.com`,
  address: `Address ${i}`,
  phone: `010-0000-${1000 + i}`,
  company: `Company ${i}`,
}));

export default function PageTest() {
  return (
    <Box sx={{ width: '100%', overflowX: 'auto' }}>
      <Box sx={{ minWidth: 1400, height: 500 }}>
        <DataGridPro
          rows={rows}
          columns={columns}
          pageSize={10}
          autoHeight={false}
          disableRowSelectionOnClick
        />
      </Box>
    </Box>
  );
}
